import React from 'react';
import { useIntl } from 'react-intl';
import { DqText } from '../../../dq-text';
import { JobMessages } from 'src/intl/JobMessages';
import './InformationModals.scss';
import { AppModal } from '../../../reusable-components/app-modal/AppModal';

interface TubesCleanedModalProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
  /**
   * Triggers the request to close the modal and submit the edit-profile.
   */
}

export const TubesCleanedModal: React.FC<TubesCleanedModalProps> = ({ onClose, isOpen }) => {
  const { formatMessage } = useIntl();

  return (
    <AppModal
      isOpen={isOpen}
      title={formatMessage(JobMessages.tubesOverTimeHeading)}
      onClose={onClose}
      primaryButton={{
        label: formatMessage(JobMessages.gotItButton),
        onClick: onClose,
      }}
    >
      <ul>
        <li>
          <DqText variant="body">{formatMessage(JobMessages.tubesOverTimeDescriptionBulletOne)}</DqText>
        </li>
        <li>
          <DqText variant="body">{formatMessage(JobMessages.tubesOverTimeDescriptionBulletTwo)}</DqText>
        </li>
      </ul>
    </AppModal>
  );
};

export default TubesCleanedModal;
